export const configurationMenuUrl = "/configuration/";

export const configurationPluginAdminEmailsPath = "/configuration/plugins/admin-emails";
export const configurationPluginUserEmailsPath = "/configuration/plugins/user-emails";

export const configurationPluginAdminEmailsUrl = () => configurationPluginAdminEmailsPath;
export const configurationPluginUserEmailsUrl = () => configurationPluginUserEmailsPath;
